import { IAPICodeDTO, IContinuousRoute } from '$/types'

/**
 * NOTE: Need to make update to reducer if we introduce new unit type.
 */
export enum RiskUnitType {
  TotalRisk = 'Total/RU',
  RiskDensity = 'Density/RU'
}

export interface IAPIRiskValue {
  valueType: 'density' | 'total'
  unit: 'RU' | 'dollar'
}

export interface ILocalFilter {
  id: number
  name: string
  segments: IContinuousRoute[]
  hmca: IAPICodeDTO[]
  classLocations: IAPICodeDTO[]
  riskLevels: IAPICodeDTO[]
}

export const EMPTY_LOCAL_FILTER: ILocalFilter = {
  id: 0,
  name: '',
  segments: [],
  hmca: [],
  classLocations: [],
  riskLevels: []
}

export const EMPTY_ROUTE = {
  name: '',
  id: -1,
  rowId: -1,
  continuousRouteId: -1,
  pipelineRouteId: -1,
  fromMeasure: 0,
  toMeasure: 0,
  initialFromMeasure: 0,
  initialToMeasure: 1000
}

export const convertRiskUnitToAPIRiskValueParameter = (
  riskUnit: RiskUnitType
): IAPIRiskValue => {
  switch (riskUnit) {
    case RiskUnitType.TotalRisk: {
      return {
        valueType: 'total',
        unit: 'RU'
      }
    }

    case RiskUnitType.RiskDensity: {
      return {
        valueType: 'density',
        unit: 'RU'
      }
    }
  }
}
